import type { AdTemplate, EditorState } from '@adflow/types';

export function editorPatchFromAdTemplate(template: AdTemplate): Partial<EditorState> {
  let teamAssetsConfig = template.displayOptions?.teamAssets;
  if (!teamAssetsConfig) {
    teamAssetsConfig = {
      type: 'JERSEY',
      fallback: 'NONE',
    };
  }

  const templateWithBg = template as AdTemplate & { bgColour?: unknown };

  return {
    name: template.name,
    bgColour: typeof templateWithBg.bgColour === 'string' ? templateWithBg.bgColour : '',
    elements: template.adElements,
    dataSources: template.dataSources,
    displayOptions: template.displayOptions ?? {
      teamAssets: teamAssetsConfig,
    },
    animation: template.animation ?? null,
    importSourceType: template.importSourceType,
    importSourceJSON: template.importSourceJSON ?? '',
    videoProjectId: template.videoProjectId ?? null,
    businessEntityId: template.businessEntityId ?? null,
    brandKitId: template.brandKitId ?? null,
    thumbnailURL: template.thumbnail ?? '',
    selectedElementId: null,
  };
}

export function applyAdTemplateToEditorStore(
  store: {
    getState: () => Record<string, unknown>;
    setState?: (partial: Partial<EditorState>, replace?: boolean) => void;
  },
  template: AdTemplate,
): void {
  if (!store.setState) {
    throw new Error('Template Builder store cannot apply a saved version.');
  }
  const patch = editorPatchFromAdTemplate(template);
  store.setState(patch);
}
